import React, { useState } from "react";
import { Container, TextField, Button, Box, Typography } from "@mui/material";
import "../styles/Section1.css";
import { sendEmail } from "../services/Request";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import PhoneAndroidRoundedIcon from "@mui/icons-material/PhoneAndroidRounded";
import AppleIcon from "@mui/icons-material/Apple";

const SignupCard = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubscribe = async (e) => {
    e.preventDefault();
    if (!email || !email.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }

    try {
      sendEmail("/mail.php", { email });
    } catch (err) {
      console.error(err);
    }
    setSubmitted(true);
  };

  return (
    <Box className="cta-banner-wrap">
      <Container maxWidth="xl">
        <div className="cta-banner-card">
          <Typography className="cta-heading">
            Your Health, Anywhere. Get Started Today.
          </Typography>
          <Typography className="cta-text">
            Join thousands of patients receiving instant virtual care and certified
            prescriptions from verified doctors. Experience healthcare without boundaries.
          </Typography>

          {submitted ? (
            <Box
              sx={{
                bgcolor: "rgba(255, 255, 255, 0.15)",
                backdropFilter: "blur(10px)",
                display: "inline-block",
                px: 4,
                py: 2,
                borderRadius: "12px",
                border: "1px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <Typography sx={{ color: "#FFFFFF", fontWeight: 700, fontSize: "16px" }}>
                ✓ Thank you! We have sent your consultation invitation to {email}.
              </Typography>
            </Box>
          ) : (
            <Box
              component="form"
              onSubmit={handleSubscribe}
              sx={{
                maxWidth: "520px",
                margin: "0 auto 32px auto",
                display: "flex",
                gap: 1.5,
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <TextField
                variant="outlined"
                size="medium"
                placeholder="Enter your email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{
                  bgcolor: "#FFFFFF",
                  flexGrow: 1,
                  borderRadius: "12px",
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                  },
                }}
              />
              <Button
                type="submit"
                variant="contained"
                endIcon={<SendRoundedIcon />}
                sx={{
                  bgcolor: "#0F172A",
                  color: "#FFFFFF",
                  fontWeight: 700,
                  fontSize: "15px",
                  px: 3.5,
                  py: 1.5,
                  borderRadius: "12px",
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  "&:hover": {
                    bgcolor: "#1E293B",
                  },
                }}
              >
                Get App Invite
              </Button>
            </Box>
          )}

          {/* App Store Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 2,
              flexWrap: "wrap",
              mt: 2,
            }}
          >
            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1.2,
                px: 2.5,
                py: 1.2,
                borderRadius: "12px",
                bgcolor: "rgba(0, 0, 0, 0.3)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                color: "#FFFFFF",
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: "rgba(0, 0, 0, 0.5)",
                },
              }}
            >
              <PhoneAndroidRoundedIcon sx={{ fontSize: 24 }} />
              <Box sx={{ textAlign: "left" }}>
                <Typography sx={{ fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.5px", opacity: 0.8 }}>
                  Download for
                </Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
                  Google Play
                </Typography>
              </Box>
            </Box>

            <Box
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: 1.2,
                px: 2.5,
                py: 1.2,
                borderRadius: "12px",
                bgcolor: "rgba(0, 0, 0, 0.3)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                color: "#FFFFFF",
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                  bgcolor: "rgba(0, 0, 0, 0.5)",
                },
              }}
            >
              <AppleIcon sx={{ fontSize: 26 }} />
              <Box sx={{ textAlign: "left" }}>
                <Typography sx={{ fontSize: "10px", textTransform: "uppercase", letterSpacing: "0.5px", opacity: 0.8 }}>
                  Download on the
                </Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: 700 }}>
                  App Store
                </Typography>
              </Box>
            </Box>
          </Box>
        </div>
      </Container>
    </Box>
  );
};

export default SignupCard;
